var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 12.5,
    viewBox: "0 0 12.5 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0cd00;}.b{fill:#ffde50;}.c{fill:#ffea94;}.d{fill:#faa300;}.e{fill:#ffbd00;}.f{fill:#f68e00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.5,6.25a6.261,6.261,0,1,1-2.019-4.6A6.25,6.25,0,0,1,12.5,6.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.275,6.416a6.25,6.25,0,0,1-6.017,6.246,6.25,6.25,0,0,1,0-12.491A6.25,6.25,0,0,1,30.275,6.416Z",
    transform: "translate(-17.775 -0.166)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.282,34.462l-8.831,8.831a6.277,6.277,0,0,1-.792-1.068l8.555-8.555A6.247,6.247,0,0,1,43.282,34.462Z",
    transform: "translate(-32.801 -32.811)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.076,94.973l-8.1,8.1a6.242,6.242,0,0,1-1.582-.909l8.778-8.778A6.231,6.231,0,0,1,103.076,94.973Z",
    transform: "translate(-91.008 -91.008)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M64.333,59.477a4.857,4.857,0,0,1-9.713.06c0-.02,0-.04,0-.06a4.857,4.857,0,0,1,4.857-4.857h.06a4.834,4.834,0,0,1,2.738.886,4.889,4.889,0,0,1,1.338,1.423A4.833,4.833,0,0,1,64.333,59.477Z",
    transform: "translate(-53.227 -53.227)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M62.911,56.042l-6.868,6.868a4.839,4.839,0,0,1-1.422-3.374c0-.02,0-.04,0-.06a4.857,4.857,0,0,1,4.857-4.857h.06a4.834,4.834,0,0,1,2.738.886A4.9,4.9,0,0,1,62.911,56.042Z",
    transform: "translate(-53.227 -53.227)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M239.376,59.477a4.857,4.857,0,0,1-4.857,4.857q-.138,0-.274-.008a4.857,4.857,0,0,0,0-9.7q.136-.008.274-.008A4.857,4.857,0,0,1,239.376,59.477Z",
    transform: "translate(-228.269 -53.227)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M117.01,127.323h-.85a2.052,2.052,0,0,0-.221-.534h1.071a.51.51,0,0,0,0-1.02h-4.82a.51.51,0,1,0,0,1.02h1.969a1.045,1.045,0,0,1,.911.534h-2.88a.51.51,0,1,0,0,1.02h2.88a1.045,1.045,0,0,1-.91.534H112.19a.51.51,0,0,0-.371.86l2.775,2.945a.51.51,0,0,0,.743-.7l-1.964-2.085h.787a2.068,2.068,0,0,0,2-1.554h.85a.51.51,0,0,0,0-1.02Z",
    transform: "translate(-108.831 -122.561)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.012,127.323h-.85a2.051,2.051,0,0,0-.221-.534h1.071a.51.51,0,0,0,0-1.02h-4.82a.51.51,0,0,0,0,1.02h1.969a1.045,1.045,0,0,1,.91.534h-2.88a.51.51,0,0,0,0,1.02h2.88a1.045,1.045,0,0,1-.91.534h-1.969a.51.51,0,0,0-.371.86l2.775,2.945a.51.51,0,1,0,.743-.7l-1.964-2.085h.788a2.068,2.068,0,0,0,2-1.554h.85a.51.51,0,1,0,0-1.02Z",
    transform: "translate(-133.195 -122.561)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.407fbf77d062f5ef5a60b447fb7716c4.svg";
export { ForwardRef as ReactComponent };